export const firstArray = (...values) => values.find((value) => Array.isArray(value)) || [];
export const firstDefined = (...values) => values.find((value) => value !== undefined && value !== null && value !== '');

export const getMatchId = (match = {}) => firstDefined(match.id, match._id, match.matchId, match.match?._id, '');
export const getMatchObject = (payload = {}) => payload.match || payload.galiMatch || payload.item || payload;
export const getConfiguration = (payload = {}) => payload.configuration || payload.matchConfiguration || payload.config || payload.match?.configuration || {};
export const getGaliConfig = (payload = {}) => getConfiguration(payload).gali || payload.gali || getMatchObject(payload).gali || {};

export const getTeams = (payload = {}) => {
  const gali = getGaliConfig(payload);
  const teams = gali.teams || payload.teams || getMatchObject(payload).teams || {};
  return {
    teamA: teams.teamA || { name: firstDefined(getMatchObject(payload).team1, 'Team A'), players: [] },
    teamB: teams.teamB || { name: firstDefined(getMatchObject(payload).team2, 'Team B'), players: [] },
  };
};

export const playerName = (player = {}) => firstDefined(
  player.displayName,
  player.name,
  player.fullName,
  player.personal?.fullName,
  player.player?.personal?.fullName,
  player.player?.displayName,
  player.user?.name,
  player.email,
  'Player'
);

export const formatDateTime = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleString();
};

export const listFromPayload = (payload = {}, keys = []) => {
  for (const key of keys) {
    const value = key.split('.').reduce((acc, part) => acc?.[part], payload);
    if (Array.isArray(value)) return value;
  }
  if (Array.isArray(payload)) return payload;
  return [];
};

export const scoreLine = (summary = {}) => {
  const explicit = firstDefined(summary.score, summary.scoreText, summary.displayScore, summary.shortScore);
  if (explicit !== undefined) return explicit;
  if (summary.runs !== undefined || summary.wickets !== undefined) return `${Number(summary.runs || 0)}/${Number(summary.wickets || 0)}`;
  return '-';
};
